var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"name-label-row-class",attrs:{"no-gutters":""}},[_c('b-col',[_vm._v(" "+_vm._s(_vm.label)+" ")])],1),_c('b-row',{staticClass:"mt-1 name-date-row-class",attrs:{"no-gutters":""}},[_c('b-col',[_vm._v(" "+_vm._s(_vm.date)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }